import { UniqueIdentifier } from "@dnd-kit/core";
import { EditorFilter } from "../types";

// // // //

/**
 * findParentByChildID
 * Finds the parent EditorFilter recursively based on a child ID.
 * @function findParentByChildID
 * @param {EditorFilter} filter - The EditorFilter to search within.
 * @param {string} id - The ID of the child filter to find its parent.
 * @returns {EditorFilter | null} - The parent EditorFilter, or null if no parent is found.
 */
export function findParentByChildID(
    filter: EditorFilter,
    id: UniqueIdentifier,
): EditorFilter | null {
    for (const nestedFilter of filter.nested) {
        if (nestedFilter.id === id) {
            return filter;
        }

        const parent = findParentByChildID(nestedFilter, id);
        if (parent) {
            return parent;
        }
    }

    return null;
}
